import type { SVGProps } from "react";
export interface PlaneAltIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneAltIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneAltIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.458 17.299c0-.298.118-.585.33-.796l3.45-3.45.1-.089a1.124 1.124 0 0 1 1.69.358l2.78 5.251.46-.46.075-.085a.88.88 0 0 0 .18-.628l-.02-.111-1.682-7.062c-.09-.38.023-.78.3-1.057l2.522-2.522.154-.171c.361-.442.735-1.167.937-1.92.113-.42.155-.785.138-1.054-.018-.282-.09-.336-.065-.31.026.025-.027-.045-.31-.064-.27-.017-.634.024-1.053.137-.755.202-1.48.575-1.92.937l-.172.154-2.523 2.524c-.276.276-.676.39-1.056.299L6.711 5.498a.88.88 0 0 0-.825.233l-.461.46 5.254 2.782a1.125 1.125 0 0 1 .268 1.788l-3.45 3.452c-.21.21-.498.329-.796.329H4.426a.88.88 0 0 0-.621.258l-.25.249 3.262 1.632.155.093c.146.106.265.246.347.41l1.63 3.261.252-.25a.88.88 0 0 0 .257-.621zm2.25 2.275c0 .83-.33 1.625-.916 2.212l-.863.862a1.626 1.626 0 0 1-2.604-.421l-1.85-3.702-3.7-1.85a1.627 1.627 0 0 1-.424-2.605l.863-.861a3.13 3.13 0 0 1 2.212-.917h1.809l2.043-2.045-4.652-2.462a1.626 1.626 0 0 1-.388-2.587L4.296 4.14a3.13 3.13 0 0 1 2.937-.832l6.45 1.535 2.078-2.077.305-.277c.756-.63 1.808-1.132 2.794-1.397.575-.154 1.195-.246 1.78-.208.572.036 1.247.207 1.758.718.51.51.683 1.185.72 1.757.037.586-.056 1.205-.21 1.78-.265.986-.767 2.04-1.396 2.795l-.279.305-2.078 2.077 1.537 6.451.04.2a3.13 3.13 0 0 1-.733 2.59l-.14.147-1.057 1.058a1.625 1.625 0 0 1-2.586-.388l-2.465-4.654-2.043 2.045z"
      />
    </svg>
  );
}
